import {React, useEffect, useState, useRef, useMemo} from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import classes from './Analytics.module.css'
import { Bar, Doughnut, Line } from "react-chartjs-2";
import { Dropdown } from "primereact/dropdown";
import { Column } from 'primereact/column';
import { DataTable } from "primereact/datatable";
import { FilterMatchMode } from 'primereact/api';
import { getSiteAnalytics, getSchedules } from "../../../Api Methods/Api";
import { authActions } from "../../../store/auth-Slice";
import { serviceActions } from "../../../store/service-Slice";
import DataManager from "../../../hooks/DataManager";
import danger from "../../../assets/portalAssets/danger.png"; 
import dangerOrange from "../../../assets/portalAssets/dangerOrange.png";
import dangerBlue from "../../../assets/portalAssets/dangerBlue.png";
import router from "../../../assets/portalAssets/router.png";
import battery100 from "../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/battery_100_green.png"
import battery50 from "../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/battery_50_orange.png"
import battery25 from "../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/battery_25_red.png"
import battery0 from "../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/battery_0.png"
import signal100 from "../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/signal_100.png"
import signal75 from "../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/signal_75.png"
import signal50 from "../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/signal_50.png"
import signal25 from "../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/signal_25.png"
import clock from "../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/clock.png"
import unlock from "../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/unlock.png"
import { GsSkeletonMainTableCard } from "../../../Pages/HolidayMode/scheduledActions";
import mixpanel from "mixpanel-browser";
import { Tooltip } from "primereact/tooltip";
import StatCard from "../../UI/Stats/StatCard";
import { da } from "date-fns/locale";
import DatePickerModal from "../Logs/DatePickerModal";
import { DateRangePicker } from "rsuite";
import ExportExcel from "../../ExcelExport/ExcelExport";
import { Button } from 'primereact/button'
import { format } from "date-fns";
import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';

const C = {
    green: "#60e08f",
    red: "#ee6d6d",
    orange: "#e8944f",
    blue: "#6298ee",
    lightBlue: "#1eb9c7"
};



const GatewayStatBar = ({ imei, gatewayBattery, signal, lastSeen, isOffline, setActiveTab, tabs, isLoading }) => (
    <div className={classes.card}  /*style={{ cursor: 'pointer' }} onClick={() => setActiveTab(tabs.indexOf("Gateway"))}*/>
        <div className={classes.cardPair}>
            <p className={classes.cardText}>
                Gateway <b>{imei}</b>
            </p>
        </div>

        <div style={{ display: 'flex', flexDirection: 'row', gap: '24px', marginLeft: 'auto' }}>
            <div className={classes.cardPair}>
                {gatewayBattery === 0 && (
                    <img className={classes.icon} style={{filter: "invert(0.5)"}} src={battery0} />
                )}
                {gatewayBattery !== null && gatewayBattery < 10 && gatewayBattery > 0 && (
                    <img className={classes.icon} src={battery25} />
                )}
                {gatewayBattery !== null && gatewayBattery >= 10 && gatewayBattery < 30 && (
                    <img className={classes.icon} src={battery50} />
                )}
                {gatewayBattery >= 30 && (
                    <img className={classes.icon} src={battery100} />
                )}
                <p className={classes.cardText}>Battery <b>{gatewayBattery}%{isOffline && ' ?'}</b></p>
            </div>

            <div className={classes.cardPair}>
                {signal >= 75 && (
                    <img className={classes.signalIcon} src={signal100} />
                )}
                {signal >= 50 && signal < 75 && (
                    <img className={classes.signalIcon} src={signal75} />
                )}
                {signal >= 25 && signal < 50 && (
                    <img className={classes.signalIcon} src={signal50} />
                )}
                {signal >= 0 && signal < 25 && (
                    <img className={classes.signalIcon} src={signal25} />
                )}
                <p className={classes.cardText}>Signal <b>{signal}%</b></p>
            </div>

            <div className={classes.lastSeen}>
                <img className={classes.clockIcon} src={clock} />
                <p className={classes.cardText}>Last seen <b>{lastSeen}</b></p>
            </div>
        </div>
    </div>
)

const LockOpenSection = ({ data, cleanPinUsername, dropdownOptions, timeConversion, handlePadlockOnClick, isLoading, hasGateways, generatePadlockPDF }) => (
    <>
        {isLoading ? (
            <>
                <div className={classes.skeleton} style={{ width: "180px", height: "16px", marginBottom: "20px", marginTop: "12px" }} />
                {[1,].map((_, index) => (
                    <div key={index} className={classes.lockCard} style={{ marginBottom: "8px" }}>
                        <div style={{ display: "flex", alignItems: "center", gap: "14px" }}>
                            <div className={classes.skeleton} style={{ width: "22px", height: "22px", borderRadius: "4px" }} />
                            <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
                                <div className={classes.skeleton} style={{ width: "120px", height: "15px" }} />
                                <div className={classes.skeleton} style={{ width: "200px", height: "13px" }} />
                            </div>
                        </div>
                        <div className={classes.skeleton} style={{ width: "180px", height: "28px", borderRadius: "6px" }} />
                    </div>
                ))}
            </>
        ) : (
            <>
                <div style={{ display:"flex", justifyContent:"space-between", alignItems: "center"}}>
                    <p className={classes.lockOpenCardTitle}>{data.length > 1 ? `Currently Open - ${data.length} Locks` : data.length == 0 ? "Currently Open - No Locks" : "Currently Open - 1 Lock"}</p>
                    {hasGateways && (
                        <Button
                            label="Export PDF"
                            icon="pi pi-file-pdf"
                            style={{
                                height: "28px",
                                fontSize: "14px",
                                padding: "6px 10px",
                                lineHeight: "1",
                            }}
                            onClick={generatePadlockPDF}
                        />
                    )}
                </div>
                {data.length < 1 ? (
                    <p className={classes.fallbackMessageSmall}>No locks are currently open.</p>
                ) : (
                    data.map((item) => {
                        const pinMatch = dropdownOptions.find(option => option.pin === item.pin);

                        const currentTime = new Date();
                        const unlockTime = new Date(item.unlockDate);
                        const secondsBetween = Math.floor((currentTime - unlockTime) / 1000);
                        return (
                            <>
                            <div className={classes.lockCard} key={item.pin}>
                                <div style={{display: "flex", alignItems: "center", gap: "14px"}} >
                                    <img className={classes.lockIcon} src={unlock} />
                                    <div style={{display: "flex", flexDirection: "column", gap: "4px"}}>
                                        {/* pass pinName, name and time*/}
                                        <p style={{ margin: 0, fontWeight: 500, fontSize: "15px", opacity: 0.7 }}>{pinMatch.value}</p>
                                        <p style={{ margin: 0, fontSize: "13px", opacity: 0.6 }}>Unlocked by {cleanPinUsername(item.unlockUserName)} - {format(new Date(item.unlockDate), "MMM do, h:mm aaa")}</p>
                                    </div>
                                </div>
                                <div style={{ display: "flex", alignItems: "center", gap: "14px" }}>
                                    <p style={{ margin: 0, fontWeight: 500, fontSize: "15px", opacity: 0.6 }}>Open for {timeConversion(secondsBetween, 'table')}</p>
                                    <button
                                        className={classes.viewLockButton}
                                        onClick={() => {handlePadlockOnClick(pinMatch.value)}}
                                    >
                                    View Lock
                                    </button>
                                </div>
                            </div>
                            {data.length > 1 && (<br />)}
                            </>
                        );
                    })
                )}
            </>
        )}
    </>
)

const UnlockLockSection = ({ pinNames, unlockLockRes, isCollapsed, handleUserClick, lockOnlyOptions, setSelectedPin, selectedPin, cleanPinUsername, selectedTime, isLoading, generatePadlockPDF, hasGateways }) => (
    <>
    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center"}}>
        <p className={classes.lockOpenCardTitle}>Open Duration History {selectedTime == "7D" ? "- Last 7 Days" : selectedTime == "1M" ? "- Last 30 Days" : selectedTime == "3M" ? "- Last 90 Days" : ""}</p>
        {!hasGateways && (
            <Button
                label="Export PDF"
                icon="pi pi-file-pdf"
                style={{
                    height: "28px",
                    fontSize: "14px",
                    padding: "6px 10px",
                    lineHeight: "1",
                }}
                onClick={generatePadlockPDF}
            />
        )}
</div>
    <Dropdown
        value={selectedPin}
        options={lockOnlyOptions}
        optionLabel="label"
        optionValue="value"
        onChange={(e) => setSelectedPin(e.value)}
        placeholder="Choose a lock"
        className={`${classes.dropdown} ${isCollapsed ? classes.dropdown : classes.dropdownCol}`}
        style={{marginLeft: "0px", width: "100%"}}
    />
    { isLoading ? (
        <GsSkeletonMainTableCard />
    ) : (
    <DataTable value={unlockLockRes} showGridlines rows={10} paginator stripedRows removableSort size= {isCollapsed ? "normal" : "small"} emptyMessage="No users found." style={{ border: "1px solid rgba(0, 0, 0, 0.2)", borderRadius: "8px", padding: "8px", marginTop: "12px" }}>
        <Column
            field="user"
            header="User"
            body={(rowData) => (
                <span
                    className={`${rowData.id != null && rowData.id !== 18965 && rowData.id !== 4133 && rowData.id !== 17103 && rowData.id !== 17428 && rowData.id !== 0 ? classes.tableUser : ''}`}
                    onClick={() => {
                        if (rowData.id != null && rowData.id !== 18965 && rowData.id !== 4133 && rowData.id !== 17103 && rowData.id !== 17428 && rowData.id !== 0) {
                            handleUserClick(rowData.id, rowData.user);
                        }
                    }}
                >
                    {cleanPinUsername(rowData.user, rowData.id, rowData.subType)}
                </span>
            )}
        />
        <Column field="openTotal" header="Opens" sortable></Column>
        <Column field="totalDuration" header="Total Open Time" sortable sortField="totalDurationRaw"></Column>
        <Column field="average" header="Average Open Time" sortable sortField="averageRaw"></Column>
        <Column field="longest" header="Longest Open" sortable sortField="longestRaw"></Column>
        <Column field="longestOn" header="Date of Longest" sortable ></Column>
    </DataTable>
    )}
    </>
)



const AnalyticsPage = ({ siteUUID, apiData, iglooLocks, isCollapsed, OutPutsPinNames, siteData, hasGateways, gatewayImei }) => {

    const [activeTab, setActiveTab] = useState(0);
    const [selectedTime, setSelectedTime] = useState("7D");
    const [scheduleFailsData, setScheduleFailsData] = useState([]);
    const [scheduleSuccesses, setScheduleSuccesses] = useState(null);
    const [securityData, setSecurityData] = useState([]);
    const [unlockData, setUnlockData] = useState([]);
    const [outputData, setOutputData] = useState([]);
    const [topOutputData, setTopOutputData] = useState([]);
    const [topUnlockData, setTopUnlockData] = useState([]);
    const [aggregatedDaily, setAggregatedDaily] = useState([]);
    const [statCards, setStatCards] = useState([]);
    const [lockHistory, setLockHistory] = useState([]);
    const [openLockData, setOpenLockData] = useState([]);
    const [topUsers, setTopUsers] = useState([]);
    const [selectedLock, setSelectedLock] = useState(null);
    const [lockStatCards, setLockStatCards] = useState([]);
    const [selectedPin, setSelectedPin] = useState(null);

    const [isLoadingSchedules, setIsLoadingSchedules] = useState(true);
    const [isLoadingSecurity, setIsLoadingSecurity] = useState(true);
    const [isLoadingLocks, setIsLoadingLocks] = useState(true);
    const [isLoadingOverview, setIsLoadingOverview] = useState(false); // change to true later
    const [isLoadingPadlocks, setIsLoadingPadlocks] = useState(true);
    const [isLoadingLeftOpen, setIsLoadingLeftOpen] = useState(true);
    const [isCheckingTabs, setIsCheckingTabs] = useState(true);
    const [hasSchedules, setHasSchedules] = useState(true);
    const [hasLocks, setHasLocks] = useState(false);

    const [filters] = useState({
        user: { value: null, matchMode: FilterMatchMode.CONTAINS }
    });
    

    const scheduleRequestId = useRef(0);
    const securityRequestId = useRef(0);
    const lockRequestId = useRef(0);

    const now = new Date();    
    const last7 = new Date();
    last7.setDate(now.getDate() - 7);
    const last14 = new Date();
    last14.setDate(now.getDate() - 14);
    const last30 = new Date();
    last30.setDate(now.getDate() - 30);
    const last90 = new Date();
    last90.setDate(now.getDate() - 90);

    // daterange stuff
    const sixMonthsAgo = new Date();
    sixMonthsAgo.setMonth(sixMonthsAgo.getMonth() - 6);
    const [aggDateRange, setAggDateRange] = useState([last7.toISOString(), now.toISOString()]);
    const [usageDateRange, setUsageDateRange] = useState([last7.toISOString(), now.toISOString()]);
    const [scheduleDateRange, setScheduleDateRange] = useState([last7.toISOString(), now.toISOString()]);
    const [securityDateRange, setSecurityDateRange] = useState([last7.toISOString(), now.toISOString()]);
    const [lockDateRange, setLockDateRange] = useState([last7.toISOString(), now.toISOString()]);
    const [modalComponent, setModalComponent] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [modalTitle, setModalTitle] = useState("Select a date range to view");


    const formatLocalDate = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}T12:00:00.000Z`;
      };

    const handleOK= (value, tab) => {
        if (value) {
            if (tab === "agg") {
                setAggDateRange([formatLocalDate(value[0]), formatLocalDate(value[1])]);
            } else if (tab === "usage") {
                setUsageDateRange([formatLocalDate(value[0]), formatLocalDate(value[1])]);
            } else if (tab === "security") {
                setSecurityDateRange([formatLocalDate(value[0]), formatLocalDate(value[1])]);
            } else if (tab === "lock") {
                setLockDateRange([formatLocalDate(value[0]), formatLocalDate(value[1])]);
            } else if (tab === "schedules") {
                setScheduleDateRange([formatLocalDate(value[0]), formatLocalDate(value[1])]);
            }
            setSelectedTime(null);
        } else {
            if (tab === "agg") {
                setAggDateRange(null);
            } else if (tab === "usage") {
                setUsageDateRange(null);
            } else if (tab === "security") {
                setSecurityDateRange(null);
            } else if (tab === "lock") {
                setLockDateRange(null);
            } else if (tab === "schedules") {
                setScheduleDateRange(null);
            }
        }
    };
      
    const disableDates = (date) => {
        return date < sixMonthsAgo || date > now;
    };
    
    const HandleModalClose = () => {
        setShowModal(false)
    };
    
    const onSelect = () => {
        HandleModalClose();
    };

    // cache  
    const cache = useRef({
        schedules: {},
        gateway: {},
        locks: {},
        outputs: {}
    });

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const dataManager = new DataManager();

    const gatewayBattery = siteData.data[0].gatewayBattery?.battery ?? null;
    const gatewayStatus = siteData.data[0].gatewayBattery?.status || null;
    const gatewaySignal = siteData.data[0].gatewayBattery?.signal ?? null;
    const gatewayLastSeen = siteData.data[0].gatewayBattery?.lastSeenAt ?? null;
    //const gatewayImei = siteData.data[0].gatewayBattery?.imei || null
    console.log("looooooggggggggg", siteData)
    const lastSeenFormatted = gatewayLastSeen ? format(new Date(gatewayLastSeen), "MMM do") : null

    const isOffline = gatewayStatus === "stale";

    const timeConversion = (seconds, type) => {
        if (seconds < 60) {
            return `${seconds}s`;
        }
        const days = Math.floor(seconds / 86400);
        const hours = Math.floor(seconds / 3600);
        const minutes = Math.floor((seconds % 3600) / 60);
        const secondsLeft = seconds % 60;


        if (days > 0 && type == "table") {
            return `${days}d ${hours % 24}h ${minutes}m`;
        }

        if (days > 0 && type == "card") {
            return `${days}d ${hours % 24}h`;
        }

        if (type === "card") {
            if (hours === 0) {
                return `${minutes}m`;
            }
            return `${hours}h ${minutes}m`;
        }

        if (hours === 0) {
            return `${minutes}m ${secondsLeft}s`;
        }

        return `${hours}h ${minutes}m ${secondsLeft}s`;
    }
    // takes in batterysignal res and parses
    const parseBatterySignal = (batterySignal) => {
        if (!batterySignal) return { battery: null, signal: null };

        const batteryMatch = batterySignal.match(/battery:\s*(\d+)%/i);
        const signalMatch = batterySignal.match(/signal:\s*(\d+)%/i);

        return {
            battery: batteryMatch ? parseInt(batteryMatch[1], 10) : null,
            signal: signalMatch ? parseInt(signalMatch[1], 10) : null
        };
    };

    const handleUserClick = (userID, fullName) => {
        dataManager.setItem('clickedUserID', userID);
        localStorage.setItem('clickedUserID', userID);
        localStorage.setItem('ClickedUserFullName', fullName);
        dispatch(authActions.setClickedUserDetails({ userID, fullName }));
        navigate('/Dashboard/Users/UserSites/');
    };

    const handlePadlockOnClick = (lockID) => {
        if (lockID) {
            dispatch(serviceActions.setLockID(lockID));
            navigate("/Dashboard/Padlocks/Lock/" + lockID);
        }
    };

    const dropdownOptions = useMemo(() =>
        OutPutsPinNames?.filter(output => output.active === 1).map(output => {
            // if output has a padlock linked to it
            const linkedLock = iglooLocks?.find(lock => lock && String(lock.outputPin) === String(output.Pin));

            if (linkedLock) {
                setHasLocks(true);
                return {
                    label: `${output.pinName} - ${linkedLock.lockID}`,
                    value: linkedLock.lockID,
                    type: 'padlock',
                    pin: output.Pin
                };
            } else {
                // regular output with no lock
                return {
                    label: output.pinName,
                    value: `output-${output.Pin}`,
                    type: 'output',
                    pin: output.Pin
                };
            }
        }) || []
    , [OutPutsPinNames, iglooLocks]);

    const lockOnlyOptions = dropdownOptions.filter(option => option.type === 'padlock');
    // const selectedLockOptions = lockOnly think i need smth like this

    const tabs = [
        "Overview",
        "Usage Analytics",
        hasSchedules && "Schedules",
        //hasGateways && "Gateway", 
        hasLocks && "Padlocks"
    ].filter(Boolean)
    const times = ["7D", "1M", "3M"]
    const selectedOption = dropdownOptions.find(option => option.value === selectedLock);

    const getScheduleData = async (selectedTime, scheduleDateRange) => {
        // cache stuff
        if (selectedTime && cache.current.schedules[selectedTime]) {
            const cached = cache.current.schedules[selectedTime];
            setScheduleFailsData(cached.failures);
            // setScheduleSuccesses(cached.totalSuccess?.total_success || 0);
            setIsLoadingSchedules(false);
            return;
        }

        const currentRequestId = ++scheduleRequestId.current;
        setIsLoadingSchedules(true);
        setScheduleFailsData([]);
        const body = {
            siteUUID: siteUUID,
            groupName: "",
            integration_type: "",
            siteType: "",
            start_date: selectedTime ? (selectedTime === "7D" ? last7 : selectedTime === "1M" ? last30 : last90) : (scheduleDateRange ? new Date(scheduleDateRange[0]) : last7),
            end_date: selectedTime ? now : scheduleDateRange ? new Date(scheduleDateRange[1]) : now,
            analyticsType: "schedules"
        }
        const res = await getSiteAnalytics(apiData, body, dispatch)
        console.log(res);
        if (currentRequestId !== scheduleRequestId.current) return;
        cache.current.schedules[selectedTime] = res.data[0];
        setScheduleFailsData(res.data[0].failures || []);
        //setScheduleSuccesses(res.data[0].totalSuccess?.total_success || 0)
        setIsLoadingSchedules(false);
    }

    const getAggregatedData = async (selectedTime, aggDateRange) => {
        setIsLoadingOverview(true);
        setAggregatedDaily([]);
        setStatCards([]);
        setTopUsers([]);
        const body = {
            siteUUID: siteUUID,
            start_date: selectedTime ? (selectedTime === "7D" ? last7 : selectedTime === "1M" ? last30 : last90) : (aggDateRange ? new Date(aggDateRange[0]) : last7),
            end_date: selectedTime ? now : aggDateRange ? new Date(aggDateRange[1]) : now,
            analyticsType: "aggregation"
        }
        const res = await getSiteAnalytics(apiData, body, dispatch)
        setIsLoadingOverview(false);
        setAggregatedDaily(res.data[0].dailyStats || []);
        setStatCards(res.data[0].statCards || []);
        setTopUsers(res.data[0].users || []);
    }

    const scheduleFailStats = useMemo(() => {
        if (!scheduleFailsData || scheduleFailsData.length === 0) return { totalFails: 0 /*, successRate: 0, totalSuccess: 0 */ };

        const totalFails = scheduleFailsData.reduce((total, item) => total + item.disarmed_fail + item.armed_fail, 0);
        //const total = totalFails + scheduleSuccesses;
        //const successRate = total === 0 ? 0 : (scheduleSuccesses / total * 100).toFixed(1);
        return { totalFails/*, successRate, totalSuccess: scheduleSuccesses */ };
    }, [scheduleFailsData/*, scheduleSuccesses */]);

    const scheduleFailStatsRef = useRef(scheduleFailStats);
    scheduleFailStatsRef.current = scheduleFailStats;

    const getSecurityData = async (selectedTime, securityDateRange) => {
        // cache
        if (selectedTime && cache.current.gateway[selectedTime]) {
            setSecurityData(cache.current.gateway[selectedTime]);
            setIsLoadingSecurity(false);
            return;
        }

        const currentRequestId = ++securityRequestId.current;
        setSecurityData([]);
        setIsLoadingSecurity(true);
        const body = {
            siteUUID: siteUUID,
            groupName: "",
            start_date: selectedTime ? (selectedTime === "7D" ? last7 : selectedTime === "1M" ? last30 : last90) : (securityDateRange ? new Date(securityDateRange[0]) : last7),
            end_date: selectedTime ? now : securityDateRange ? new Date(securityDateRange[1]) : now,
            analyticsType: "gateways"
        }
        const res = await getSiteAnalytics(apiData, body, dispatch)
        if (currentRequestId !== securityRequestId.current) return;
        cache.current.gateway[selectedTime] = res.data[0];
        setSecurityData(res.data[0])
        setIsLoadingSecurity(false);
    }
        

    const getSecurityStats = (securityData) => {
        if (!securityData || securityData.length === 0) return { totalInvalidPins: 0, hasBatteryData: false, hasSignalData: false, latestBattery: null, latestSignal: null };

        const totalInvalidPins = securityData.reduce((total, item) => total + (item.invalid_pin_count || 0), 0);

        const hasBatteryData = securityData.some(item => item.battery !== null && item.battery !== undefined);
        const hasSignalData = securityData.some(item => item.signal !== null && item.signal !== undefined);

        const latestBattery = securityData.findLast(item => item.battery !== null && item.battery !== undefined)?.battery;
        const latestSignal = securityData.findLast(item => item.signal !== null && item.signal !== undefined)?.signal;

        return { totalInvalidPins, hasBatteryData, hasSignalData, latestBattery, latestSignal };
    }
        

    const cleanPinUsername = (user, id, subType, includeEnd = true) => {
        // id + subtype given
        if (id !== undefined && subType !== undefined) {
            if (subType === "MASTER_PIN_UNLOCK") return "Master PIN";
            if (user?.trim() === "unlocked by" || user?.trim() === "" || !user) return includeEnd ? "Unknown - Pin" : "Unknown";
            if (id == null || id === 0) {
                const match = user?.match(/unlocked by (.+?) using a/);
                const name = match ? match[1] : user;
                return includeEnd ? `${name} - Pin` : name;
            }
            return user;
        }

        // otherwis
        if (!user) return user;
        if (user.includes("unlocked by") && user.includes("using a")) {
            const match = user.match(/unlocked by (.+?) using a/);
            return match ? match[1].trim() : user;
        }
        return user;
    };

    const getUnlockData = async (selectedTime, usageDateRange) => {
        /* const cacheKey = `${selectedLock}-${rangeType}`;

        // check cache
        if (cache.current.locks[cacheKey]) {
            const cached = cache.current.locks[cacheKey];
            setUnlockData(cached.unlocks);
            setTopUnlockData(cached.mostActiveUsers);
            setIsLoadingLocks(false);
            return;
        } */

        const currentRequestId = ++lockRequestId.current;
        setUnlockData([]);
        setIsLoadingLocks(true);
        const body = {
            siteUUID: siteUUID,
            lockID: selectedLock,
            start_date: selectedTime ? (selectedTime === "7D" ? last7 : selectedTime === "1M" ? last30 : last90) : (usageDateRange ? new Date(usageDateRange[0]) : last7),
            end_date: selectedTime ? now : usageDateRange ? new Date(usageDateRange[1]) : now,
            analyticsType: "locks"
        }
        const res = await getSiteAnalytics(apiData, body, dispatch)
        if (currentRequestId !== lockRequestId.current) return;
        //cache.current.locks[cacheKey] = res.data[0];

        const cleanedUsers = (res.data[0].mostActiveUsers || []).map(user => ({
            ...user,
            user: cleanPinUsername(user.user)
        }));

        setUnlockData(res.data[0].unlocks)
        setTopUnlockData(cleanedUsers)
        setIsLoadingLocks(false);
    }

    const getLockStats = (unlockData) => {
        if (!unlockData || unlockData.length === 0) return { totalUnlocks: 0 }
        const totalUnlocks = unlockData.reduce((total, item) => total + item.unlocked_by_count + item.lock_unlock_open_count, 0);
        return { totalUnlocks }
    }

    const getOutputData = async (rangeType, outputPin, selectedTime, usageDateRange) => {
        const cacheKey = `${outputPin}-${rangeType}`;

        // check cache
        if (rangeType && cache.current.outputs[cacheKey]) {
            const cached = cache.current.outputs[cacheKey];
            setOutputData(cached.actions || []);
            setTopOutputData(cached.mostActiveUsers || []);
            setIsLoadingLocks(false);
            return;
        }

        const currentRequestId = ++lockRequestId.current;
        setOutputData([]);
        setIsLoadingLocks(true);

        const body = {
            siteUUID: siteUUID,
            pin: outputPin,
            start_date: selectedTime ? (selectedTime === "7D" ? last7 : selectedTime === "1M" ? last30 : last90) : (usageDateRange ? new Date(usageDateRange[0]) : last7),
            end_date: selectedTime ? now : usageDateRange ? new Date(usageDateRange[1]) : now,
            analyticsType: "outputs"
        }
        const res = await getSiteAnalytics(apiData, body, dispatch)
        if (currentRequestId !== lockRequestId.current) return;
        cache.current.outputs[cacheKey] = res.data?.[0];
        setOutputData(res.data?.[0]?.actions || [])
        setTopOutputData(res.data?.[0]?.mostActiveUsers || [])
        setIsLoadingLocks(false);
    }

    const getPadlockLeftOpen = async () => {
        setOpenLockData([]);
        setIsLoadingLeftOpen(true);

        const body = {
            siteUUID: siteUUID,
            analyticsType: "locksLeftOpen"
        }
        const res = await getSiteAnalytics(apiData, body, dispatch)
        setOpenLockData(res.data?.[0]?.lockLeftOpen || [])
        setIsLoadingLeftOpen(false);
    }

    const getPadlockData = async (selectedTime, lockDateRange) => {
        const selectedPinOption = lockOnlyOptions.find(opt => opt.value === selectedPin);
        if (!selectedPinOption) return;

        setLockHistory([]);
        setIsLoadingPadlocks(true);
        const body = {
            siteUUID: siteUUID,
            start_date: selectedTime ? (selectedTime === "7D" ? last7 : selectedTime === "1M" ? last30 : last90) : (lockDateRange ? new Date(lockDateRange[0]) : last7),
            end_date: selectedTime ? now : lockDateRange ? new Date(lockDateRange[1]) : now,
            pinNumber: selectedPinOption.pin,
            analyticsType: "unlockedLockHistory"
        }
        const res = await getSiteAnalytics(apiData, body, dispatch)
        const rawData = res.data?.[0]?.unlockedLockDuration || [];

        // adding up everything per user
        const userMap = {};
        rawData.forEach(item => {
            const userName = item.unlockUserName || item.unlockEventData;

            if (!userMap[userName]) {
                userMap[userName] = {
                    user: userName,
                    id: 0,
                    subType: null,
                    openTotal: 0,
                    totalDuration: 0,
                    average: 0,
                    longest: 0,
                    longestOn: null
                };
            }

            userMap[userName].id = item.unlockUserID;
            userMap[userName].subType = item.subType;
            userMap[userName].openTotal += 1;
            userMap[userName].totalDuration += item.secondsOpen;
            userMap[userName].average = userMap[userName].totalDuration / userMap[userName].openTotal;

            if (item.secondsOpen > userMap[userName].longest) {
                userMap[userName].longest = item.secondsOpen;
                userMap[userName].longestOn = item.unlockDate;
            }
        });

        // get user stats
        const users = Object.values(userMap);
        const mostFrequent = users.length > 0 ? users.reduce((max, u) => u.openTotal > max.openTotal ? u : max, users[0]) : null;
        const highestTotal = users.length > 0 ? users.reduce((max, u) => u.totalDuration > max.totalDuration ? u : max, users[0]) : null;
        const longestSingle = users.length > 0 ? users.reduce((max, u) => u.longest > max.longest ? u : max, users[0]) : null;

        const aggregated = users.map(user => ({
            ...user,
            totalDurationRaw: user.totalDuration,
            totalDuration: timeConversion(user.totalDuration, "table"),
            longestRaw: user.longest,
            longest: timeConversion(user.longest, "table"),
            averageRaw: Math.round(user.average),
            average: timeConversion(Math.round(user.average), "table"),
            longestOn: user.longestOn ? format(new Date(user.longestOn), "yyyy-MM-dd, h:mm aaa") : null
        }));
        console.log("Aggregated lock history:", aggregated);

        let total = 0;
        let totalOpenTime = 0;
        let longestOpenTime = 0;

        rawData.forEach(item => {
            total += 1;
            totalOpenTime += item.secondsOpen;
            if (item.secondsOpen > longestOpenTime) {
                longestOpenTime = item.secondsOpen;
            }
        });

        const avgOpenTime = total > 0 ? Math.round(totalOpenTime / total) : 0;
        setLockStatCards({
            total,
            totalOpenTime: timeConversion(totalOpenTime, "card"),
            avgOpenTime: timeConversion(avgOpenTime, "card"),
            longestOpenTime: timeConversion(longestOpenTime, "card"),
            mostFrequentUser: cleanPinUsername(mostFrequent?.user, mostFrequent?.id, mostFrequent?.subType, false) || 'N/A',
            highestTotalUser: cleanPinUsername(highestTotal?.user, highestTotal?.id, highestTotal?.subType, false) || 'N/A',
            longestSingleUser: cleanPinUsername(longestSingle?.user, longestSingle?.id, longestSingle?.subType, false) || 'N/A'
        });

        setLockHistory(aggregated);
        setIsLoadingPadlocks(false);
    }

    const generatePadlockPDF = () => {
        const doc = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4' });
        const pageW = doc.internal.pageSize.getWidth();
        const margin = 18;

        // Get date range for display
        let startDate, endDate;
        if (selectedTime) {
            endDate = now;
            startDate = selectedTime === "7D" ? last7 : selectedTime === "1M" ? last30 : last90;
        } else if (lockDateRange) {
            startDate = new Date(lockDateRange[0]);
            endDate = new Date(lockDateRange[1]);
        } else {
            startDate = last7;
            endDate = now;
        }
        const dateRangeStr = `${format(startDate, "MMM d, yyyy")} - ${format(endDate, "MMM d, yyyy")}`;

        // Get selected lock name
        const selectedPinOption = lockOnlyOptions.find(opt => opt.value === selectedPin);
        const lockName = selectedPinOption?.label || 'Padlock';

        // Header bar
        doc.setFillColor(28, 37, 54);
        doc.rect(0, 0, pageW, 32, 'F');
        doc.setTextColor(255, 255, 255);
        doc.setFont('helvetica', 'bold');
        doc.setFontSize(16);
        doc.text(`${lockName} - Open Duration Report`, margin, 14);
        doc.setFontSize(9);
        doc.setFont('helvetica', 'normal');
        doc.setTextColor(180, 195, 220);
        doc.text(dateRangeStr, pageW - margin, 14, { align: 'right' });
        doc.text(`Generated: ${format(new Date(), "MMM d, yyyy")}`, pageW - margin, 22, { align: 'right' });

        // Stats section
        let curY = 44;
        doc.setTextColor(30, 30, 30);
        doc.setFont('helvetica', 'bold');
        doc.setFontSize(11);
        doc.text('Summary Statistics', margin, curY);
        curY += 10;

        // Stats grid - 2 columns
        const statItems = [
            { label: 'Total Opens', value: lockStatCards.total || 0 },
            { label: 'Most Frequent User', value: lockStatCards.mostFrequentUser || 'N/A' },
            { label: 'Total Open Time', value: lockStatCards.totalOpenTime || '0m' },
            { label: 'Highest Total User', value: lockStatCards.highestTotalUser || 'N/A' },
            { label: 'Average Open Time', value: lockStatCards.avgOpenTime || '0m' },
            { label: 'Longest Single User', value: lockStatCards.longestSingleUser || 'N/A' },
            { label: 'Longest Single Open', value: lockStatCards.longestOpenTime || '0m' },
        ];

        doc.setFontSize(9);
        const colWidth = (pageW - margin * 2) / 2;
        statItems.forEach((item, i) => {
            const col = i % 2;
            const row = Math.floor(i / 2);
            const x = margin + col * colWidth;
            const y = curY + row * 12;

            doc.setFont('helvetica', 'normal');
            doc.setTextColor(100, 100, 100);
            doc.text(item.label + ':', x, y);
            doc.setFont('helvetica', 'bold');
            doc.setTextColor(30, 30, 30);
            doc.text(String(item.value), x + 45, y);
        });

        curY += Math.ceil(statItems.length / 2) * 12 + 10;

        // Currently Open Locks section (only if site has gateways)
        if (hasGateways && openLockData && openLockData.length > 0) {
            doc.setFont('helvetica', 'bold');
            doc.setFontSize(11);
            doc.setTextColor(180, 100, 0);
            doc.text(`Currently Open - ${openLockData.length} Lock${openLockData.length > 1 ? 's' : ''}`, margin, curY);
            curY += 8;

            doc.setFontSize(9);
            openLockData.forEach((item) => {
                const pinMatch = dropdownOptions.find(option => option.pin === item.pin);
                const lockLabel = pinMatch?.value || `Pin ${item.pin}`;
                const currentTime = new Date();
                const unlockTime = new Date(item.unlockDate);
                const secondsBetween = Math.floor((currentTime - unlockTime) / 1000);
                const openDuration = timeConversion(secondsBetween, 'table');

                doc.setFillColor(255, 243, 224);
                doc.rect(margin, curY - 4, pageW - margin * 2, 10, 'F');

                doc.setFont('helvetica', 'bold');
                doc.setTextColor(50, 50, 50);
                doc.text(lockLabel, margin + 3, curY + 2);
                doc.setFont('helvetica', 'normal');
                doc.setTextColor(100, 100, 100);
                doc.text(`- Unlocked by ${cleanPinUsername(item.unlockUserName)} - Open for ${openDuration}`, margin + 3 + doc.getTextWidth(lockLabel) + 2, curY + 2);
                curY += 12;
            });

            curY += 4;
        }

        // Divider line
        doc.setDrawColor(200, 200, 200);
        doc.line(margin, curY, pageW - margin, curY);
        curY += 10;

        // Table header
        doc.setFont('helvetica', 'bold');
        doc.setFontSize(11);
        doc.setTextColor(30, 30, 30);
        doc.text('User Open Duration Details', margin, curY);
        curY += 8;

        // Data table
        const tableData = lockHistory.map(row => [
            cleanPinUsername(row.user, row.id, row.subType),
            row.openTotal,
            row.totalDuration,
            row.average,
            row.longest,
            row.longestOn || 'N/A'
        ]);

        autoTable(doc, {
            startY: curY,
            margin: { left: margin, right: margin },
            head: [['User', 'Opens', 'Total Open Time', 'Avg Open Time', 'Longest Open', 'Date of Longest']],
            body: tableData,
            headStyles: { fillColor: [28, 37, 54], textColor: [255, 255, 255], fontSize: 8, fontStyle: 'bold' },
            bodyStyles: { fontSize: 8, textColor: [50, 50, 50] },
            alternateRowStyles: { fillColor: [249, 250, 251] },
            columnStyles: {
                0: { cellWidth: 'auto' },
                1: { halign: 'center', cellWidth: 16 },
                2: { halign: 'center', cellWidth: 28 },
                3: { halign: 'center', cellWidth: 26 },
                4: { halign: 'center', cellWidth: 26 },
                5: { halign: 'center', cellWidth: 36 },
            },
            styles: { cellPadding: 3 },
        });

        // Footer
        const pageH = doc.internal.pageSize.getHeight();
        doc.setFillColor(28, 37, 54);
        doc.rect(0, pageH - 14, pageW, 14, 'F');
        doc.setTextColor(180, 195, 220);
        doc.setFontSize(7);
        doc.setFont('helvetica', 'normal');
        doc.text('Portal Analytics Report', pageW / 2, pageH - 6, { align: 'center' });

        const filename = `padlock-report-${lockName.replace(/\s+/g, '-').toLowerCase()}-${format(new Date(), "yyyy-MM-dd")}.pdf`;
        doc.save(filename);
    };

    // for date range charts
    const getDaysBetween = (start, end) => {
        const startDate = new Date(start);
        const endDate = new Date(end);
        const timeDiff = Math.abs(endDate - startDate);
        return Math.ceil(timeDiff / (1000 * 60 * 60 * 24)) + 1;
    };

     // for 3 months - schedules
    const processedScheduleData = useMemo(() => {
    if (!scheduleFailsData) return [];

    let days;
    let startDate;

    if (selectedTime) {
      days = selectedTime === "7D" ? 8 : selectedTime === "1M" ? 30 : 90;
      startDate = new Date();
      startDate.setDate(startDate.getDate() - (days - 1));
    } else if (scheduleDateRange) {
      days = getDaysBetween(scheduleDateRange[0], scheduleDateRange[1]);
      startDate = new Date(scheduleDateRange[0]);
    } else {
      days = 8;
      startDate = new Date();
      startDate.setDate(startDate.getDate() - 7);
    }

    const result = Array.from({ length: days }, (_, i) => {
      const date = new Date(startDate);
      date.setDate(startDate.getDate() + i);
      return {
        event_date: date.toISOString().split('T')[0],
        armed_fail: 0,
        disarmed_fail: 0
      };
    });

    // replace 0s
    scheduleFailsData.forEach(item => {
      const dateKey = new Date(item.event_date).toISOString().split('T')[0];
      const match = result.find(r => r.event_date === dateKey);
      if (match) {
        match.armed_fail = item.armed_fail;
        match.disarmed_fail = item.disarmed_fail;
      }
    });

    return result;
    }, [scheduleFailsData, selectedTime, scheduleDateRange]);

    // aggregated full days
    const processedAggregatedDaily = useMemo(() => {
        if (!aggregatedDaily) return [];

        let days;
        let startDate;

        if (selectedTime) {
            days = selectedTime === "7D" ? 8 : selectedTime === "1M" ? 30 : 90;
            startDate = new Date();
            startDate.setDate(startDate.getDate() - (days - 1));
        } else if (aggDateRange) {
            days = getDaysBetween(aggDateRange[0], aggDateRange[1]);
            startDate = new Date(aggDateRange[0]);
        } else {
            days = 8;
            startDate = new Date();
            startDate.setDate(startDate.getDate() - 7);
        }

        const result = Array.from({ length: days }, (_, i) => {
            const date = new Date(startDate);
            date.setDate(startDate.getDate() + i);
            return {
                event_date: date.toISOString().split('T')[0],
                outputs: 0,
                lock_unlocks: 0,
                schedule_failures: 0
            };
        });

        aggregatedDaily.forEach(item => {
            const dateKey = new Date(item.event_date).toISOString().split('T')[0];
            const match = result.find(r => r.event_date === dateKey);
            if (match) {
                match.outputs = item.outputs;
                match.lock_unlocks = item.lock_unlocks;
                match.schedule_failures = item.schedule_failures;
            }
        });
        return result;
    }, [aggregatedDaily, selectedTime, aggDateRange]);

    // output full days
    const processedOutputData = useMemo(() => {
        if (!outputData) return [];

        let days;
        let startDate;

        if (selectedTime) {
            days = selectedTime === "7D" ? 8 : selectedTime === "1M" ? 30 : 90;
            startDate = new Date();
            startDate.setDate(startDate.getDate() - (days - 1));
        } else if (usageDateRange) {
            days = getDaysBetween(usageDateRange[0], usageDateRange[1]);
            startDate = new Date(usageDateRange[0]);
        } else {
            days = 8;
            startDate = new Date();
            startDate.setDate(startDate.getDate() - 7);
        }

        const result = Array.from({ length: days }, (_, i) => {
            const date = new Date(startDate);
            date.setDate(startDate.getDate() + i);
            return {
                event_date: date.toISOString().split('T')[0],
                arm_count: 0,
                disarm_count: 0,
                pulse_count: 0
            };
        });

        outputData.forEach(item => {
            const dateKey = new Date(item.event_date).toISOString().split('T')[0];
            const match = result.find(r => r.event_date === dateKey);
            if (match) {
                match.arm_count = item.arm_count;
                match.disarm_count = item.disarm_count;
                match.pulse_count = item.pulse_count;
            }
        });
        return result;
    }, [outputData, selectedTime, usageDateRange]);

    // unlocks full days
    const processedUnlockData = useMemo(() => {
        if (!unlockData) return [];

        let days;
        let startDate;

        if (selectedTime) {
            days = selectedTime === "7D" ? 8 : selectedTime === "1M" ? 30 : 90;
            startDate = new Date();
            startDate.setDate(startDate.getDate() - (days - 1));
        } else if (usageDateRange) {
            days = getDaysBetween(usageDateRange[0], usageDateRange[1]);
            startDate = new Date(usageDateRange[0]);
        } else {
            days = 8;
            startDate = new Date();
            startDate.setDate(startDate.getDate() - 7);
        }

        const result = Array.from({ length: days }, (_, i) => {
            const date = new Date(startDate);
            date.setDate(startDate.getDate() + i);
            return {
                event_date: date.toISOString().split('T')[0],
                unlocked_by_count: 0,
                lock_unlock_open_count: 0
            };
        });

        unlockData.forEach(item => {
            const dateKey = new Date(item.event_date).toISOString().split('T')[0];
            const match = result.find(r => r.event_date === dateKey);
            if (match) {
                match.unlocked_by_count = item.unlocked_by_count;
                match.lock_unlock_open_count = item.lock_unlock_open_count;
            }
        });
        return result;
    }, [unlockData, selectedTime, usageDateRange])

    // gateway full days
    const processedSecurityData = useMemo(() => {
        if (!securityData) return [];

        let days;
        let startDate;

        if (selectedTime) {
            days = selectedTime === "7D" ? 8 : selectedTime === "1M" ? 30 : 90;
            startDate = new Date();
            startDate.setDate(startDate.getDate() - (days - 1));
        } else if (securityDateRange) {
            days = getDaysBetween(securityDateRange[0], securityDateRange[1]);
            startDate = new Date(securityDateRange[0]);
        } else {
            days = 8;
            startDate = new Date();
            startDate.setDate(startDate.getDate() - 7);
        }

        const result = Array.from({ length: days }, (_, i) => {
            const date = new Date(startDate);
            date.setDate(startDate.getDate() + i);
            return {
                event_date: date.toISOString().split('T')[0],
                battery: null,
                signal: null,
                invalid_pin_count: 0
            };
        });

        securityData.forEach(item => {
            const dateKey = new Date(item.event_date).toISOString().split('T')[0];
            const match = result.find(r => r.event_date === dateKey);
            if (match) {
                match.battery = item.battery;
                match.signal = item.signal;
                match.invalid_pin_count = item.invalid_pin_count;
            }
        });
        return result;
    }, [securityData, selectedTime, securityDateRange]);
    // getting proper period to use for chart
    const getPeriod = (type) => {
        switch (type) {
        case 'agg':
            if (selectedTime) return selectedTime;
            if (!aggDateRange) return "7D";
            const aggDays = getDaysBetween(aggDateRange[0], aggDateRange[1]);
            if (aggDays <= 10) return "7D";
            if (aggDays <= 45) return "1M";
            return "3M";
        case 'usage':
            if (selectedTime) return selectedTime;
            if (!usageDateRange) return "7D";
            const usageDays = getDaysBetween(usageDateRange[0], usageDateRange[1]);
            if (usageDays <= 10) return "7D";
            if (usageDays <= 45) return "1M";
            return "3M";
        case 'security':
            if (selectedTime) return selectedTime;
            if (!securityDateRange) return "7D";
            const securityDays = getDaysBetween(securityDateRange[0], securityDateRange[1]);
            if (securityDays <= 10) return "7D";
            if (securityDays <= 45) return "1M";
            return "3M";
        case 'lock':
            if (selectedTime) return selectedTime;
            if (!lockDateRange) return "7D";
            const lockDays = getDaysBetween(lockDateRange[0], lockDateRange[1]);
            if (lockDays <= 10) return "7D";
            if (lockDays <= 45) return "1M";
            return "3M";
        case 'schedules':
            if (selectedTime) return selectedTime;
            if (!scheduleDateRange) return "7D";
            const scheduleDays = getDaysBetween(scheduleDateRange[0], scheduleDateRange[1]);
            if (scheduleDays <= 10) return "7D";
            if (scheduleDays <= 45) return "1M";
            return "3M";
        default:
            return "3M";
        }
    };

    const aggPeriod = getPeriod('agg');
    const usagePeriod = getPeriod('usage');
    const securityPeriod = getPeriod('security');
    const lockPeriod = getPeriod('lock');
    const schedulePeriod = getPeriod('schedules');

    const formatEventDate = (dateStr, period) => {
        if (!dateStr) return '';
        const date = new Date(dateStr);
        if (isNaN(date.getTime())) return dateStr;
        

        switch (period) {
        case '7D':
            return date.toLocaleDateString('en-US', { weekday: 'short' });
        case '1M':
            return `${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
        case '3M':
            return date.toLocaleDateString('en-US', { month: 'short', day: '2-digit' });
        default:
            return dateStr;
        }
    };

    const formatImei = (imei) => {
        const formattedImei = imei.slice(-4);
        return "x" + formattedImei;
    }

// charts -------------------------------------------------

    const barChartData = {
        labels: processedScheduleData.map(item => formatEventDate(item.event_date, schedulePeriod)),
        datasets: [
            {
                label: 'Failed Arm Schedules',
                data: processedScheduleData.map(item => item.armed_fail),
                backgroundColor: C.red
            },
            {
                label: 'Failed Disarm Schedules',
                data: processedScheduleData.map(item => item.disarmed_fail),
                backgroundColor: C.orange
            }
        ]
    }

    const doughnutData = {
        labels: ['Success', 'Arm Failed', 'Disarm Failed'],
        datasets: [
            {
                data: [/* scheduleSuccesses || 0 */, scheduleFailsData?.reduce((total, item) => total + item.armed_fail, 0), scheduleFailsData?.reduce((total, item) => total + item.disarmed_fail, 0)],
                backgroundColor: [C.green, C.red, C.orange]
            }
        ]
    };

    const lineData1 = {
        labels: processedSecurityData.map(item => formatEventDate(item.event_date, securityPeriod)),
        datasets: [
            /* {
                type: 'line',
                label: "Invalid PIN Attempts",
                data: processedSecurityData.map(item => item.invalid_pin_count),
                fill: true,
                backgroundColor: 'rgba(255, 99, 132, 0.01)',
                borderColor: C.red,
                tension: 0.5,
                pointRadius: 6,
                pointHoverRadius: 8,
                yAxisID: 'y1'
            },
            */
           {
                type: 'bar',
                label: "Battery Level",
                data: processedSecurityData.map(item => item.battery),
                backgroundColor: C.green,
                borderRadius: 4,
                yAxisID: 'y'
           },
           {
                type: 'bar',
                label: "Signal Strength",
                data: processedSecurityData.map(item => item.signal),
                backgroundColor: C.lightBlue,
                borderRadius: 4,
                yAxisID: 'y'
           }
        ]
    };

    const lineData1Options = {
        scales: {
            y: {
                type: 'linear',
                position: 'left',
                title: {
                    display: true,
                    text: 'Percentage (%)'
                },
                min: 0,
                max: 100
            },
            y1: {
                type: 'linear',
                position: 'right',
                title: {
                    display: true,
                    text: 'Invalid PINs'
                },
                ticks: {
                    stepSize: 1,
                    precision: 0
                },
                grid: {
                    drawOnChartArea: false
                }
            }
        }
    };

    const lineData2 = {
        labels: processedUnlockData.map(item => formatEventDate(item.event_date, usagePeriod)),
        datasets: [
            {
                label: `Opens via App`,
                data: processedUnlockData.map(item => item.unlocked_by_count),
                fill: true,
                backgroundColor: 'rgba(128, 119, 221, 0.01)',
                borderColor: 'rgba(128, 119, 221, 1)',
                tension: 0.5,
                pointRadius: 2,
                pointHoverRadius: 8
            },
            {
                label: "Opens via Pin",
                data: processedUnlockData.map(item => item.lock_unlock_open_count),
                fill: true,
                backgroundColor: 'rgba(221, 81, 68, 0.01)',
                borderColor: 'rgba(221, 80, 68, 1)',
                tension: 0.5,
                pointRadius: 2,
                pointHoverRadius: 8
            }
        ]
    };

    const fallbackLineData2 = {
        labels: processedUnlockData.map(item => formatEventDate(item.event_date, usageDateRange)),
        datasets: [
            {
                label: `Opens via App`,
                data: processedUnlockData.map(item => item.unlocked_by_count),
                backgroundColor: 'rgb(0, 200, 255)',
                borderWidth: 1,
                borderRadius: 8,
            },
            {
                label: "Opens via Pin",
                data: processedUnlockData.map(item => item.lock_unlock_open_count),
                backgroundColor: C.red,
                borderWidth: 1,
                borderRadius: 8,
            }
        ]
    };

    const barData2 = {
        labels: topUnlockData.slice(0, 5).map(item => {
            if (item.id == null) {
                const match = item.user.match(/unlocked by (.+?) using a/);
                const name = match ? match[1] : item.user;
                return `${name} - Pin`;
            }
            return `${item.user} - App`;
        }),
        datasets: [
            {
                label: "Unlocks",
                data: topUnlockData.slice(0, 5).map(item => item.count),
                backgroundColor: ["#60e08f", "#6298ee", "#efbc65", "#df7474", "#75c71e"],
                borderWidth: 1,
                borderRadius: 8,
            }
        ]
    };

    const outputLineData = {
        labels: processedOutputData.map(item => formatEventDate(item.event_date, usageDateRange)),
        datasets: [
            {
                label: "Arms",
                data: processedOutputData.map(item => item.arm_count),
                backgroundColor: 'rgba(98, 152, 238, 0.01)',
                borderColor: C.blue,
                borderWidth: 2,
                borderRadius: 8,
                tension: 0.5,
                pointRadius: 2,
                pointHoverRadius: 8,
                fill: true,
            },
            {
                label: "Disarms",
                data: processedOutputData.map(item => item.disarm_count),
                backgroundColor: 'rgba(96, 224, 143, 0.01)',
                borderColor: C.green,
                borderWidth: 2,
                tension: 0.5,
                pointRadius: 2,
                pointHoverRadius: 8,
                fill: true,
                
            },
            {
                label: "Pulses",
                data: processedOutputData.map(item => item.pulse_count),
                backgroundColor: 'rgba(238, 109, 109, 0.01)',
                borderColor: C.red,
                borderWidth: 2,
                borderRadius: 8,
                tension: 0.5,
                pointRadius: 2,
                pointHoverRadius: 8,
                fill: true,
            }
        ]
    };

    const fallbackOutputBarData = {
        labels: processedOutputData.map(item => formatEventDate(item.event_date, usagePeriod)),
        datasets: [
            {
                label: "Arms",
                data: processedOutputData.map(item => item.arm_count),
                backgroundColor: C.blue,
                borderWidth: 1,
                borderRadius: 8,
                tension: 0.5,
                pointRadius: 6,
                pointHoverRadius: 8,
                fill: true,
            },
            {
                label: "Disarms",
                data: processedOutputData.map(item => item.disarm_count),
                backgroundColor: C.green,
                borderWidth: 1,
                borderRadius: 8,
                tension: 0.5,
                pointRadius: 6,
                pointHoverRadius: 8,
                fill: true,
            },
            {
                label: "Pulses",
                data: processedOutputData.map(item => item.pulse_count),
                backgroundColor: C.red,
                borderWidth: 1,
                borderRadius: 8,
                tension: 0.5,
                pointRadius: 6,
                pointHoverRadius: 8,
                fill: true,
            }
        ]
    };
    const outputBarData = {
        labels: topOutputData.slice(0, 5).map(item => item.user),
        datasets: [
            {
                label: "Actions",
                data: topOutputData.slice(0, 5).map(item => item.count),
                backgroundColor: ["#60e08f", "#6298ee", "#efbc65", "#df7474", "#75c71e"],
                borderWidth: 1,
                borderRadius: 8,
            }
        ]
    };

    const aggregatedData = {
        labels: processedAggregatedDaily.map(item => formatEventDate(item.event_date, aggPeriod)),
        datasets: [
            {
                type: 'line',
                label: 'Outputs',
                data: processedAggregatedDaily.map(item => item.outputs),
                fill: true,
                backgroundColor: 'rgba(98, 152, 238, 0.01)',
                borderColor: C.green,
                borderWidth: 2,
                borderRadius: 8,
                tension: 0.5,
                pointRadius: 2,
                pointHoverRadius: 8,
            },
            {
                type: 'line',
                label: 'Unlocks',
                data: processedAggregatedDaily.map(item => item.lock_unlocks),
                fill: true,
                backgroundColor: 'rgba(238, 109, 109, 0.01)',
                borderColor: C.blue,
                borderWidth: 2,
                borderRadius: 8,
                tension: 0.5,
                pointRadius: 2,
                pointHoverRadius: 8,
            },
            {
                type: 'bar',
                label: 'Schedule Fails',
                data: processedAggregatedDaily.map(item => item.schedule_failures),
                backgroundColor: C.red,
                borderWidthh: 1,
                borderRadius: 8,
            }
        ]
    }


    // schedule check
    useEffect(() => {
        const checkSchedules = async () => {
            const res = await getSchedules(apiData, siteUUID, dispatch);
            setHasSchedules(res.data && res.data.length > 0);
            setIsCheckingTabs(false);
        };
        if (siteUUID && apiData) checkSchedules();

        mixpanel.track("Analytics tab visited", {
              user: localStorage.getItem('email')
        });
    }, [siteUUID])

    useEffect(() => {
        setSelectedTime("7D");
        setAggDateRange(null);
        setUsageDateRange(null);
        setScheduleDateRange(null);
        setSecurityDateRange(null);
        setLockDateRange(null);
    }, [activeTab]);

    useEffect(() => {
        if (siteUUID && apiData && !isCheckingTabs && tabs[activeTab] === "Schedules") {
            getScheduleData(selectedTime, scheduleDateRange)
        }
    }, [selectedTime, siteUUID, activeTab, isCheckingTabs, scheduleDateRange])

    useEffect(() => {
        if (siteUUID && apiData && !isCheckingTabs && tabs[activeTab] === "Gateway") {
            getSecurityData(selectedTime, securityDateRange)
        }
    }, [selectedTime, siteUUID, activeTab, isCheckingTabs, securityDateRange])

    useEffect(() => {
        const selectedOption = dropdownOptions.find(option => option.value === selectedLock);
        if (siteUUID && apiData && !isCheckingTabs && selectedLock && tabs[activeTab] === "Usage Analytics" && selectedOption?.type === 'padlock') {
            getUnlockData(selectedTime, usageDateRange)
        }

        if (siteUUID && apiData && !isCheckingTabs && selectedLock && tabs[activeTab] === "Usage Analytics" && selectedOption?.type === 'output') {
            getOutputData(selectedTime, selectedOption.pin, selectedTime, usageDateRange)
        }
    }, [selectedTime, selectedLock, activeTab, isCheckingTabs, usageDateRange])

    useEffect(() => {
        if (tabs[activeTab] === "Overview") {
            getAggregatedData(selectedTime, aggDateRange);
        }
    }, [activeTab, selectedTime, aggDateRange])

    useEffect(() => {
        if (tabs[activeTab] === "Padlocks" && selectedPin) {
            getPadlockData(selectedTime, lockDateRange);
        }
    }, [activeTab, selectedTime, selectedPin, lockDateRange])

    useEffect(() => {
        if (tabs[activeTab] === "Padlocks") {
            getPadlockLeftOpen();
        }
    }, [activeTab])

    // first dropdown option on open
    useEffect(() => {
        if (tabs[activeTab] === "Usage Analytics" && !selectedLock && dropdownOptions.length > 0) {
            setSelectedLock(dropdownOptions[0].value);
        }
    }, [activeTab, dropdownOptions, selectedLock])

    // first lock option for padlocks
    useEffect(() => {
        if (tabs[activeTab] === "Padlocks" && !selectedPin && lockOnlyOptions.length > 0) {
            setSelectedPin(lockOnlyOptions[0].value);
        }
    }, [activeTab, lockOnlyOptions, selectedPin])


    if (isCheckingTabs) {
        return (
            <div style={{ padding: "20px" }}>
                <div style={{ display: "flex", gap: "6px", marginLeft: "8px", marginBottom: "20px" }}>
                    <div className={`${classes.skeleton}`} style={{ width: "100px", height: "30px" }} />
                    <div className={`${classes.skeleton}`} style={{ width: "100px", height: "30px" }} />
                    <div className={`${classes.skeleton}`} style={{ width: "100px", height: "30px" }} />
                </div>
                <div className={`${classes.skeleton} ${classes.skeletonChart}`} />
            </div>
        );
    }

    return (
        <div className={classes.tabsWrapper}>
        
        <div className={classes.tabs}>
            {tabs.map((tab, i) => (
                <button key={tab} 
                    className={`${classes.tab} ${activeTab === i ? classes.active : ""}`}
                    onClick={() => setActiveTab(i)}>
                    {tab}
                </button>
            ))}
        </div>

        <div className={classes.tabContent}>
        {tabs[activeTab] === "Overview" && (
            <div style={{ padding: '0px 22px'}}>
                <div className={classes.overviewHeader}>
                    <div className={classes.title}>
                        <h2>Aggregated site activity</h2>
                    </div>
                    <div style={{ display: "flex", gap: "14px", marginLeft: "auto" }}>
                    
                            <div>
                                <DatePickerModal show={showModal} onClose={HandleModalClose} title={modalTitle} onSelect={onSelect}>
                                {modalComponent}
                                </DatePickerModal>
                            </div>
                            <DateRangePicker style={{
                                display: "flex",
                                border: "1px solid #00000099",
                                borderRadius: "8px",
                                height: "30px",
                                width: "218px",
                                }}
                                placement="bottomEnd"
                                format="yyyy.MM.dd"
                                onChange={(value) => handleOK(value, "agg")}
                                shouldDisableDate={disableDates}
                                calendarSnapping={true}
                                appearance="subtle"
                                onClean={() => {
                                  setAggDateRange(null)
                                  setSelectedTime("7D")
                                }}
                                cleanable={true}
                                ranges={[]}
                                value={aggDateRange ? [new Date(aggDateRange[0]), new Date(aggDateRange[1])] : null}
                            />
                        

                        <div className={classes.timeButtons}>
                            {times.map((time) => (
                                <button
                                    key={time}
                                    className={selectedTime === time ? classes.timeButtonActive : classes.timeButton}
                                    onClick={() => {
                                        setSelectedTime(time)
                                        setAggDateRange(null)
                                    }}
                                >
                                    {time}
                                </button>
                            ))}
                            {isCollapsed && (
                            <button 
                            className={classes.exploreButton}
                            onClick={() => setActiveTab(1)}>
                            Find out more
                        </button>
                        )}
                        </div>
                    </div>
                </div>

                {hasGateways && (
                    <>
                    < br/>
                    <GatewayStatBar imei={formatImei(gatewayImei)} gatewayBattery={gatewayBattery} isOffline={isOffline} signal={gatewaySignal} lastSeen={lastSeenFormatted} setActiveTab={setActiveTab} tabs={tabs} />
                    </>
                )}

                    <div style={{ display: "flex", gap: "20px", marginTop: "20px", flexWrap: "wrap" }}>
                        <div style={{ flex: "1 1 200px", minWidth: "200px", maxWidth: "calc(50% - 10px)" }}>
                            <StatCard title={"Output actions"} value={statCards[0]?.total_outputs || 0} hasLabel={true} label={"Arms, disarms, pulses"} isLoading={isLoadingOverview} />
                        </div>
                        <div style={{ flex: "1 1 200px", minWidth: "200px", maxWidth: "calc(50% - 10px)" }}>
                            <StatCard title={"Total unlocks"} value={statCards[0]?.total_lock_unlocks || 0} hasLabel={true} label={"Across all padlocks"} isLoading={isLoadingOverview} />
                        </div>
                        <div style={{ flex: "1 1 200px", minWidth: "200px", maxWidth: "calc(50% - 10px)" }}>
                            <StatCard title={"Schedule fails"} value={statCards[0]?.total_schedule_failures || 0} hasLabel={true} label={"Failed arm/disarm"} isLoading={isLoadingOverview} />
                        </div>
                        <div style={{ flex: "1 1 200px", minWidth: "200px", maxWidth: "calc(50% - 10px)" }}>
                            <StatCard title={"Active users"} value={topUsers.length || 0} hasLabel={true} label={"Unique this period"} isLoading={isLoadingOverview} />
                        </div>
                    </div>
                    

                <br />
                
                <div className={isCollapsed ?classes.overviewGraphs : classes.overviewGraphsCol}>
                    <div className={isCollapsed ?classes.overviewBar : classes.overviewBarCol}>
                        {isLoadingOverview ? (
                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '20px' }}>
                                <div className={classes.skeleton} style={{ width: '280px', height: '16px', marginBottom: '20px' }} />
                                <div className={classes.skeleton} style={{ width: '100%', height: isCollapsed ? '300px' : '250px', borderRadius: '8px' }} />
                            </div>

                        ) : !statCards[0]?.total_outputs && !statCards[0]?.total_schedule_failures && !statCards[0]?.total_lock_unlocks ? (
                            <div className={`${classes.fallbackMessage} ${isCollapsed ? classes.fallbackMessageCollapsed : ''}`}>
                                <p>No site activity to display</p>
                            </div>
                        ) : (
                            <Bar
                                data={aggregatedData}
                            />
                        )}
                    </div>
                    {!isCollapsed && (
                        <br />
                    )}
                    <div className={isCollapsed ? classes.topUsersCard : classes.topUsersCardCol}>
                        <p className={classes.topUsersCardTitle}>Top Active Users</p>
                        {isLoadingOverview ? (
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '16px', paddingTop: '10px' }}>
                                <div className={classes.skeleton} style={{ width: '100%', height: '20px', borderRadius: '4px' }} />
                                <div className={classes.skeleton} style={{ width: '85%', height: '20px', borderRadius: '4px' }} />
                                <div className={classes.skeleton} style={{ width: '70%', height: '20px', borderRadius: '4px' }} />
                                <div className={classes.skeleton} style={{ width: '55%', height: '20px', borderRadius: '4px' }} />
                                <div className={classes.skeleton} style={{ width: '40%', height: '20px', borderRadius: '4px' }} />
                            </div>
                        ) : topUsers.length === 0 ? (
                            <div className={`${classes.fallbackMessage} ${isCollapsed ? classes.fallbackMessageCollapsedUsers : ''}`}>
                                <p>No users to display</p>
                            </div>
                        ) : (
                            <div
                                className={classes.userBarRows}
                                style={topUsers.length < 5 ? { justifyContent: 'flex-start', gap: `${topUsers.length * 12}px`, flex: 'none' } : {}}
                            >
                                {topUsers.slice(0,5).map((user, i) => {
                                    const colors = ["#60e08f", "#df74cb", "#6298ee", "#efbc65", "#75c71e"];
                                    return (
                                        <div 
                                            key={i} 
                                            className={classes.userBarRow}
                                            style={{cursor: user.fullName?.includes("unlocked by") ? "" : "pointer"}}
                                            onClick={() => {
                                                {!user.fullName?.includes("unlocked by") && 
                                                    handleUserClick(user.id, user.fullName)
                                                }
                                            }}>
                                            <span className={classes.userBarName}>
                                                {user.fullName?.includes("unlocked by")
                                                    ? cleanPinUsername(user.fullName)
                                                    : user.fullName}
                                            </span>
                                            <div className={isCollapsed ? classes.userBarTrack : classes.userBarTrackCol} >
                                                <div
                                                    className={classes.userBarFill}
                                                    style={{ width: `${(user.actions / topUsers[0]?.actions) * 100}%`, background: colors[i % colors.length] }}
                                                />
                                            </div>
                                            <span className={classes.userBarCount}>
                                                {user.actions}
                                                {user.fullName?.includes("unlocked by") && (
                                                    <span style={{ fontSize: '10px', opacity: 0.5, marginLeft: '8px' }}>(Pin)</span>
                                                )}
                                            </span>
                                        </div>
                                    );
                                })}
                            </div>
                        )}
                    </div>
                </div>

            </div>
        )}


        {tabs[activeTab] === "Schedules" && (
        <div className={isCollapsed ? classes.schedulesContainer : classes.schedulesContainerCol}>
            {/* 
            <div className={classes.doughnutSection}>
                <div className={classes.doughnutHeader}>
                    <div className={classes.title}>
                        <h2>Schedule success rate</h2>
                        <p>Pass/fail breakdown for all schedules</p>
                    </div>
                    <div className={classes.timeButtons}>
                        {times.map((time) => (
                            <button
                                key={time}
                                className={selectedTime === time ? classes.timeButtonActive : classes.timeButton}
                                onClick={() => setSelectedTime(time)}
                            >
                                {time}
                            </button>
                        ))}
                    </div>
                </div>
                {isLoadingSchedules ? (
                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", padding: "20px" }}>
                        <div className={`${classes.skeleton} ${classes.skeletonDoughnut}`} />
                        <div className={`${classes.skeleton}`} style={{ width: "120px", height: "16px", marginTop: "38px" }} />
                    </div>
                ) :
                scheduleFailStats.successRate === 0 ? (
                    <div className={`${classes.fallbackMessage} ${isCollapsed ? classes.fallbackMessageCollapsed : ''}`}>
                        <p>No data available.</p>
                    </div>
                ) : (
                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", marginTop: "32px" }}>
                        <div style={{ height: "350px" }}>
                            <Doughnut
                                key={`doughnut-${selectedTime}-${scheduleFailStats.successRate}`}
                                data={doughnutData}
                                options={{
                                    cutout: '60%',
                                    plugins: {
                                        legend: {
                                            position: 'bottom'
                                        }
                                    }
                                }}
                                plugins={[{
                                    id: 'centerText',
                                    beforeDraw: (chart) => {
                                        const { ctx, chartArea } = chart;
                                        if (!chartArea) return;

                                        const centerX = (chartArea.left + chartArea.right) / 2;
                                        const centerY = (chartArea.top + chartArea.bottom) / 2;
                                        const successRate = scheduleFailStatsRef.current.successRate;

                                        ctx.save();
                                        ctx.globalAlpha = 0.6;

                                        ctx.font = "600 28px sans-serif";
                                        ctx.textBaseline = "middle";
                                        ctx.textAlign = "center";
                                        ctx.fillStyle = "#000";
                                        ctx.fillText(`${successRate}%`, centerX, centerY - 8);

                                        ctx.font = "400 12px sans-serif";
                                        ctx.fillText("Success rate", centerX, centerY + 14);

                                        ctx.restore();
                                    }
                                }]}
                            />
                        </div>
                    </div>
                )}
            </div>
            */}


            <div style ={{ display: "flex", flexDirection: "column", flex: 1, minWidth: 0, width: "95%"}}>
                <div className={classes.barHeader}>
                    <div className={classes.title} style={{ marginLeft: "22px" }}>
                        <h2>Schedule fails</h2>
                        <p>Failed schedules over time</p>
                    </div>
                    <div style={{ display: "flex", gap: "14px", marginLeft: "auto" }}>
                        <div>
                            <DatePickerModal show={showModal} onClose={HandleModalClose} title={modalTitle} onSelect={onSelect}>
                            {modalComponent}
                            </DatePickerModal>
                        </div>
                        <DateRangePicker style={{
                            display: "flex",
                            border: "1px solid #00000099",
                            borderRadius: "8px",
                            height: "30px",
                            maxWidth: "218px",
                            minWidth: isCollapsed ? "218px" : "150px"
                            }}
                            placement="bottomEnd"
                            format="yyyy.MM.dd"
                            onChange={(value) => handleOK(value, "schedules")}
                            shouldDisableDate={disableDates}
                            calendarSnapping={true}
                            appearance="subtle"
                            onClean={() => {
                                setScheduleDateRange(null)
                                setSelectedTime("7D")
                                }}
                            cleanable={true}
                            ranges={[]}
                            value={lockDateRange ? [new Date(lockDateRange[0]), new Date(lockDateRange[1])] : null}
                        />
                        <div className={classes.timeButtons}>
                                {times.map((time) => (
                                    <button
                                        key={time}
                                        className={selectedTime === time ? classes.timeButtonActive : classes.timeButton}
                                        onClick={() => {
                                            setSelectedTime(time)
                                            setScheduleDateRange(null)
                                        }}
                                    >
                                        {time}
                                    </button>
                                ))}
                        </div>
                    </div>
                </div>
                {isLoadingSchedules ? (
                    <div style={{ padding: "20px" }}>
                        <div className={classes.skeletonStat} style={{ marginLeft: "8px", marginTop: "20px" }}>
                            <div className={`${classes.skeleton} ${classes.skeletonStatLabel}`} />
                            <div className={`${classes.skeleton} ${classes.skeletonStatValue}`} />
                        </div>
                        <div className={`${classes.skeleton} ${classes.skeletonChart}`} style={{ height: "350px" }} />
                    </div>
                ) :
                scheduleFailStats.totalFails === 0 ? (
                    <div className={`${classes.fallbackMessage} ${isCollapsed ? classes.fallbackMessageCollapsed : ''}`}>
                        <p>No schedule fails for the selected time period</p>
                    </div>
                ) : (
                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", marginTop: "32px", marginLeft: "8px", width: "95%" }}>
                        <div style={{ height: "350px", width: "100%" }}>
                            <Bar
                                data={barChartData}
                                options={{
                                        scales: {
                                            y: {
                                                ticks: {
                                                    stepSize: 1,
                                                    precision: 0
                                                }
                                            }
                                        }
                                    }}
                            />
                        </div>

                        <p style={{ fontSize: "14px", fontWeight: "400", opacity: "0.7", marginTop: "24px" }}>
                            Total fails: {scheduleFailStats.totalFails}
                        </p>
                    </div>
                )}
            </div>
        </div>
        )}

        {tabs[activeTab] === "Gateway" && (
            <div>
                <div className={`${classes.securityStatsHeader} ${isCollapsed ? classes.securityStatsHeader : classes.securityStatsHeaderCol}`}>
                    <div className={classes.title}>
                        <div style={{ display: "flex", alignItems: "center", justifyContent: isCollapsed ? "space-between" : "", gap: isCollapsed ? "0" : "8px" }}>
                            <h2>Gateway Stats</h2>
                            {gatewayBattery !== null && gatewayBattery < 10 && gatewayBattery > 0 && (
                                <>
                                    <Tooltip key={`critical-${isCollapsed}`} target="#gatewayInfoCritical" position={isCollapsed ? "right" : "top"} className={classes.customTooltip} />
                                    <span id="gatewayInfoCritical" className={classes.redInfoButton} data-pr-tooltip={isOffline ? "Gateway is offline & last battery is critical. Charge immediately." : "Battery critical. Charge immediately."}><img className={classes.infoIcon} src={danger} /></span>
                                </>
                            )}
                            {gatewayBattery !== null && gatewayBattery >= 10 && gatewayBattery < 30 && (
                                <>
                                    <Tooltip key={`low-${isCollapsed}`} target="#gatewayInfoLow" position={isCollapsed ? "right" : "top"} className={classes.customTooltip} />
                                    <span id="gatewayInfoLow" className={classes.orangeInfoButton} data-pr-tooltip={isOffline ? "Gateway is offline & last battery is low. Consider charging." : "Battery is low. Consider charging."}><img className={classes.infoIcon} src={dangerOrange} /></span>
                                </>
                            )}
                            {gatewayBattery >= 30 && isOffline && (
                                <>
                                    <Tooltip key={`offline-${isCollapsed}`} target="#gatewayInfoOffline" position={isCollapsed ? "right" : "top"} className={classes.customTooltip} />
                                    <span id="gatewayInfoOffline" className={classes.blueInfoButton} data-pr-tooltip="Gateway is offline. Battery level may be innacurate. Check connection."><img className={classes.infoIcon} src={dangerBlue} /></span>
                                </>
                            )}
                            {gatewayBattery == 0 && (
                                <>
                                    <Tooltip key={`dead-${isCollapsed}`} target="#gatewayInfoDead" position={isCollapsed ? "right" : "top"} className={classes.customTooltip} />
                                    <span id="gatewayInfoDead" className={classes.redInfoButton} data-pr-tooltip="Gateway battery is dead. Please charge."><img className={classes.infoIcon} src={danger} /></span>
                                </>
                            )}

                        </div>
                        <p>Battery levels & signal strength</p>
                    </div>
                    <div style={{ display: "flex", gap: "14px", marginLeft: "auto" }}> 
                        <div>
                            <DatePickerModal show={showModal} onClose={HandleModalClose} title={modalTitle} onSelect={onSelect}>
                            {modalComponent}
                            </DatePickerModal>
                        </div>
                            <DateRangePicker style={{
                                display: "flex",
                                border: "1px solid #00000099",
                                borderRadius: "8px",
                                height: "30px",
                                maxWidth: "218px",
                                minWidth: isCollapsed ? "218px" : "160px"
                                }}
                                placement="bottomEnd"
                                format="yyyy.MM.dd"
                                onChange={(value) => handleOK(value, "security")}
                                shouldDisableDate={disableDates}
                                calendarSnapping={true}
                                appearance="subtle"
                                onClean={() => {
                                  setSecurityDateRange(null)
                                  setSelectedTime("7D")
                                }}
                                cleanable={true}
                                ranges={[]}
                                value={securityDateRange ? [new Date(securityDateRange[0]), new Date(securityDateRange[1])] : null}
                            />
                        <div className={classes.timeButtons}>
                            {times.map((time, i) => (
                                <button 
                                    key={time} 
                                    className={`classes.timeButton ${selectedTime === time ? classes.timeButtonActive : classes.timeButton}`}
                                    onClick={() => {
                                        setSelectedTime(time)
                                        setSecurityDateRange(null)
                                    }}
                                >
                                    {time}
                                </button>
                            ))}
                        </div>
                    </div>
                </div>

                {isLoadingSecurity ? (
                    <div style={{ padding: "20px" }}>
                        <div style={{ display: "flex", gap: "39px" }}>
                            <div className={classes.skeletonStat}>
                                <div className={`${classes.skeleton} ${classes.skeletonStatLabel}`} />
                                <div className={`${classes.skeleton} ${classes.skeletonStatValue}`} />
                            </div>
                            <div className={classes.skeletonStat}>
                                <div className={`${classes.skeleton} ${classes.skeletonStatLabel}`} style={{ width: "120px" }} />
                                <div className={`${classes.skeleton} ${classes.skeletonStatValue}`} />
                            </div>
                            <div className={classes.skeletonStat}>
                                <div className={`${classes.skeleton} ${classes.skeletonStatLabel}`} style={{ width: "120px" }} />
                                <div className={`${classes.skeleton} ${classes.skeletonStatValue}`} />
                            </div>
                        </div>
                        <div className={`${classes.skeleton} ${classes.skeletonChart}`} />
                    </div>
                ) : (
                    <>
                        <div className={classes.statsContainer}>
                            {/* 
                            <div className={classes.stat}>
                                <p>Invalid PINs</p>
                                <h1>{getSecurityStats(securityData).totalInvalidPins}</h1>
                            </div>
                            */}
                            <div className={classes.stat}>     
                                <p>Latest Battery Level</p>
                                <h1>{gatewayBattery}%</h1>
                            </div>

                            <div className={classes.stat}>
                                <p>Latest Signal Strength</p>
                                <h1>{getSecurityStats(securityData).latestSignal || 0}%</h1>
                            </div>
                        </div>
                        {!getSecurityStats(securityData).hasBatteryData && !getSecurityStats(securityData).hasSignalData && !getSecurityStats(securityData).totalInvalidPins ? (
                            <div className={`${classes.fallbackMessage} ${isCollapsed ? classes.fallbackMessageCollapsed : ''}`}>
                                <p>No gateway analytics for the selected time period</p>
                            </div>
                        ) : (
                            
                        <div className={`${classes.securityChart} ${isCollapsed ? '' : classes.securityChartCol}`}>
                            <Bar
                                data={lineData1}
                                //options={lineData1Options}
                                options={{
                                            scales: {
                                                y: {
                                                    ticks: {
                                                        stepSize: 1,
                                                        precision: 0
                                                    }
                                                }
                                            }
                                        }}
                            />
                        </div>
                        )}
                        
                    </>
                )}
                

            </div>
            
        )}

        {tabs[activeTab] === "Usage Analytics" && (
            <>
            <div style={{ display: "flex", alignItems: "center", gap: "14px", marginBottom: "16px", marginRight: "22px" }}>
                <Dropdown
                    value={selectedLock}
                    options={dropdownOptions}
                    optionLabel="label"
                    optionValue="value"
                    onChange={(e) => setSelectedLock(e.value)}
                    placeholder="Choose an output or lock"
                    className={`${classes.dropdown} ${isCollapsed ? classes.dropdown : classes.dropdownCol}`}
                />
                {selectedLock && (selectedOption?.type === "padlock" || selectedOption?.type === "output") && (
                    <div style={{ display: "flex", gap: "14px", alignItems: "center", marginLeft: "auto" }}>
                        
                                <DatePickerModal show={showModal} onClose={HandleModalClose} title={modalTitle} onSelect={onSelect}>
                                    {modalComponent}
                                </DatePickerModal>
                                <DateRangePicker style={{
                                    display: "flex",
                                    border: "1px solid #00000099",
                                    borderRadius: "8px",
                                    height: "30px",
                                    maxWidth: "218px",
                                    minWidth: isCollapsed ? "218px" : "180px",
                                    }}
                                    placement="bottomEnd"
                                    format="yyyy.MM.dd"
                                    onChange={(value) => handleOK(value, "usage")}
                                    shouldDisableDate={disableDates}
                                    calendarSnapping={true}
                                    appearance="subtle"
                                    onClean={() => {
                                        setUsageDateRange(null)
                                        setSelectedTime("7D")
                                    }}
                                    cleanable={true}
                                    ranges={[]}
                                    value={usageDateRange ? [new Date(usageDateRange[0]), new Date(usageDateRange[1])] : null}
                                />
                            
                        <div className={classes.timeButtons}>
                            {times.map((time, i) => (
                                <button
                                key={time}
                                className={`classes.timeButton ${selectedTime === time ? classes.timeButtonActive : classes.timeButton}`}
                                onClick={() => {
                                    setSelectedTime(time)
                                    setUsageDateRange(null)
                                }}
                            >
                                    {time}
                                </button>
                            ))}
                        </div>
                    </div>
                )}
            </div>
            {!selectedLock && (
                <div style={{ fontSize: "14px", fontWeight: "400", marginTop: "38px", textAlign: "center" }}>
                    <p>Please select an output or lock</p>
                </div>
            )}

            {selectedLock && selectedOption?.type === "padlock" && (
            <>
                <div className={isCollapsed ? classes.padlocksContainer : classes.padlocksContainerCol}>
                    <div className={classes.padlocksLeft}>
                            <div className={`${classes.statsHeader2} ${isCollapsed ? classes.statsHeader2 : classes.statsHeaderCol2}`}>
                                <div className={classes.title}>
                                    <h2>Padlock unlocks</h2>
                                    <p>Unlock activity by lock</p>
                                </div>
                            </div>

                            {isLoadingLocks ? (
                                <div style={{ padding: "20px", width: isCollapsed ? "500px" : "100%" }}>
                                    <div className={classes.skeletonStat} style={{ marginLeft: "4px" }}>
                                        <div className={`${classes.skeleton} ${classes.skeletonStatLabel}`} style={{ width: "40px" }} />
                                        <div className={`${classes.skeleton} ${classes.skeletonStatValue}`} />
                                    </div>
                                    <div className={`${classes.skeleton} ${classes.skeletonChart}`} style={{ height: "280px" }} />
                                </div>
                            ) : getLockStats(unlockData).totalUnlocks === 0 ? (
                                <div className={`${classes.fallbackMessage} ${isCollapsed ? classes.fallbackMessageCollapsed : ''}`} style={{ width: isCollapsed ? "500px" : "100%" }}>
                                    <p>No padlock analytics for the selected time period</p>
                                </div>
                            ) : (
                            <>
                            <div className={classes.padlockStatsContainer}>
                                    <div className={classes.padlockStat}>
                                        <p>Total</p>
                                        <h1>{getLockStats(unlockData).totalUnlocks}</h1>
                                    </div>
                            </div>
                            {unlockData.length <= 1 ? (
                                <div className={`${classes.padlockChart} ${isCollapsed ? classes.padlockChartCollapsed : classes.padlockChartCol}`}>
                                    <Bar
                                        data={fallbackLineData2}
                                        options={{
                                            scales: {
                                                y: {
                                                    ticks: {
                                                        stepSize: 1,
                                                        precision: 0
                                                    }
                                                }
                                            }
                                        }}
                                    />
                                </div>
                            ) : (
                                <div className={`${classes.padlockChart} ${isCollapsed ? classes.padlockChartCollapsed : classes.padlockChartCol}`}>
                                    <Line
                                        data={lineData2}
                                        options={{
                                            scales: {
                                                y: {
                                                    ticks: {
                                                        stepSize: 1,
                                                        precision: 0
                                                    }
                                                }
                                            }
                                        }} />
                                </div>
                            )}
                        </>
                        )}
                        </div>

                    <div style ={{ display: "flex", flexDirection: "column"}}>
                        <div className={`${classes.title} ${isCollapsed ? classes.title : classes.titleCol}`}>
                            <h2>Top 5 padlock users</h2>
                            {selectedTime === "7D" ? (
                                <p>Most active users in the last 7 days</p>
                            ) : selectedTime === "1M" ? (
                                <p>Most active users in the last month</p>
                            ) : selectedTime === "3M" ? (
                                <p>Most active users in the last 3 months</p>
                            ) : (
                                <p>Most active users within time frame</p>
                            )}
                        </div>

                        {isLoadingLocks ? (
                            <div className={`${classes.topUsersChart} ${isCollapsed ? classes.topUsersChartCollapsed : classes.topUsersChartCol}`}>
                                <div className={classes.skeletonBarsContainer}>
                                    <div className={`${classes.skeleton} ${classes.skeletonBar}`} style={{ width: "100%" }} />
                                    <div className={`${classes.skeleton} ${classes.skeletonBar}`} style={{ width: "95%" }} />
                                    <div className={`${classes.skeleton} ${classes.skeletonBar}`} style={{ width: "85%" }} />
                                    <div className={`${classes.skeleton} ${classes.skeletonBar}`} style={{ width: "75%" }} />
                                    <div className={`${classes.skeleton} ${classes.skeletonBar}`} style={{ width: "60%" }} />
                                    <div className={`${classes.skeleton} ${classes.skeletonBar}`} style={{ width: "55%" }} />
                                    <div className={`${classes.skeleton} ${classes.skeletonBar}`} style={{ width: "30%" }} />
                                </div>
                            </div>
                        ) : (!topUnlockData || topUnlockData.length === 0) ? (
                                <div className={`${classes.fallbackMessage} ${isCollapsed ? classes.fallbackMessageCollapsed : ''}`}>
                                    <p>No users to display</p>
                                </div>
                        ) : (
                            <div className={`${classes.topUsersChart} ${isCollapsed ? classes.topUsersChartCollapsed : classes.topUsersChartCol}`}>
                                <div className={classes.userLegend}>
                                    {topUnlockData.slice(0, 5).map((item, index) => {
                                        const colors = ["#60e08f", "#6298ee", "#efbc65", "#df7474", "#75c71e"];
                                        return (
                                            <div
                                                key={item.user}
                                                className={classes.userLegendItem}
                                                onClick={() => {
                                                    if (item.id != null && item.id != 18965 && item.id != 4133 && item.id != 17103 && item.id != 17428) {
                                                        console.log('clicked on:', item.user, item.id);
                                                        handleUserClick(item.id, item.user);
                                                    }
                                                }}
                                            >
                                                <span
                                                    className={classes.userLegendDot}
                                                    style={{ backgroundColor: colors[index % colors.length] }}
                                                />
                                                <span>{item.id == null ? (() => { const match = item.user.match(/unlocked by (.+?) using a/); return match ? `${match[1]} - Pin` : `${item.user} - Pin`; })() : `${item.user} - App`}</span>
                                            </div>
                                        );
                                    })}
                                </div>
                                <Bar
                                    data={barData2}
                                    options={{
                                        indexAxis: 'y',
                                        plugins: {
                                            legend: {
                                                display: false
                                            }
                                        }
                                    }}
                                />
                            </div>
                        )}

                    </div>
                </div>

                {topUnlockData.length > 5 && (
                    <div className={`${classes.dataTableWrapper} ${!isCollapsed ? classes.dataTableWrapperCol : ''}`}>
                        <DataTable value={topUnlockData} scrollable scrollHeight="400px" stripedRows style={{ border: "1px solid rgba(0, 0, 0, 0.2)", borderRadius: "8px", padding: "8px"}}>
                            <Column
                                field="user"
                                header="User"
                                body={(rowData) => (
                                    <span
                                        className={`${rowData.id != null && rowData.id !== 18965 && rowData.id !== 4133 && rowData.id !== 17103 && rowData.id !== 17428 ? classes.tableUser : ''}`}
                                        onClick={() => {
                                            if (rowData.id != null && rowData.id !== 18965 && rowData.id !== 4133 && rowData.id !== 17103 && rowData.id !== 17428) {
                                                handleUserClick(rowData.id, rowData.user);
                                            }
                                        }}
                                    >
                                        {rowData.id == null ? (() => { const match = rowData.user.match(/unlocked by (.+?) using a/); return match ? `${match[1]} - Pin` : `${rowData.user} - Pin`; })() : `${rowData.user} - App`}
                                    </span>
                                )}
                            />
                            <Column field="count" header="Unlock Count"></Column>
                        </DataTable>
                    </div>
                )}
            </>
            )}

            {selectedLock && selectedOption?.type === "output" && (
            <>
                <div className={isCollapsed ? classes.padlocksContainer : classes.padlocksContainerCol}>
                    <div className={classes.padlocksLeft}>
                            <div className={`${classes.statsHeader2} ${isCollapsed ? classes.statsHeader2 : classes.statsHeaderCol2}`}>
                                <div className={classes.title}>
                                    <h2>Output activity</h2>
                                    <p>Activity by output</p>
                                </div>
                            </div>

                            {isLoadingLocks ? (
                                <div style={{ padding: "20px", width: isCollapsed ? "500px" : "100%" }}>
                                    <div className={classes.skeletonStat} style={{ marginLeft: "4px" }}>
                                        <div className={`${classes.skeleton} ${classes.skeletonStatLabel}`} style={{ width: "40px" }} />
                                        <div className={`${classes.skeleton} ${classes.skeletonStatValue}`} />
                                    </div>
                                    <div className={`${classes.skeleton} ${classes.skeletonChart}`} style={{ height: "280px" }} />
                                </div>
                            ) : (!outputData || outputData.length === 0 || outputData.every(item => item.arm_count === 0 && item.disarm_count === 0 && item.pulse_count === 0)) ? (
                                <div className={`${classes.fallbackMessage} ${isCollapsed ? classes.fallbackMessageCollapsed : ''}`} style={{ width: isCollapsed ? "500px" : "100%" }}>
                                    <p>No output analytics for the selected time period</p>
                                </div>
                            ) : (
                            <>
                            <div className={classes.padlockStatsContainer}>
                                    <div className={classes.padlockStat}>
                                        <p>Total</p>
                                        <h1>{outputData.reduce((total, item) => total + item.arm_count + item.disarm_count + item.pulse_count, 0)}</h1>
                                    </div>
                            </div>
                            {outputData.length <= 1 ? (
                                <div className={`${classes.padlockChart} ${isCollapsed ? classes.padlockChartCollapsed : classes.padlockChartCol}`}>
                                    <Bar
                                        data={fallbackOutputBarData}
                                        options={{
                                            scales: {
                                                y: {
                                                    ticks: {
                                                        stepSize: 1,
                                                        precision: 0
                                                    }
                                                }
                                            }
                                        }}
                                    />
                                </div>
                            ) : (
                                <div className={`${classes.padlockChart} ${isCollapsed ? classes.padlockChartCollapsed : classes.padlockChartCol}`}>
                                    <Line
                                        data={outputLineData}
                                        options={{
                                            scales: {
                                                y: {
                                                    ticks: {
                                                        stepSize: 1,
                                                        precision: 0
                                                    }
                                                }
                                            }
                                        }} />
                                </div>
                            )}
                        </>
                        )}
                        </div>

                    <div style ={{ display: "flex", flexDirection: "column"}}>
                        <div className={`${classes.title} ${isCollapsed ? classes.title : classes.titleCol}`}>
                            <h2>Top 5 output users</h2>
                            {selectedTime === "7D" ? (
                                <p>Most active users in the last 7 days</p>
                            ) : selectedTime === "1M" ? (
                                <p>Most active users in the last month</p>
                            ) : selectedTime === "3M" ? (
                                <p>Most active users in the last 3 months</p>
                            ) : (
                                <p>Most active users within time frame</p>
                            )}
                        </div>

                        {isLoadingLocks ? (
                            <div className={`${classes.topUsersChart} ${isCollapsed ? classes.topUsersChartCollapsed : classes.topUsersChartCol}`}>
                                <div className={classes.skeletonBarsContainer}>
                                    <div className={`${classes.skeleton} ${classes.skeletonBar}`} style={{ width: "90%" }} />
                                    <div className={`${classes.skeleton} ${classes.skeletonBar}`} style={{ width: "75%" }} />
                                    <div className={`${classes.skeleton} ${classes.skeletonBar}`} style={{ width: "60%" }} />
                                    <div className={`${classes.skeleton} ${classes.skeletonBar}`} style={{ width: "45%" }} />
                                    <div className={`${classes.skeleton} ${classes.skeletonBar}`} style={{ width: "30%" }} />
                                </div>
                            </div>
                        ) : (!topOutputData || topOutputData.length === 0 || topOutputData.every(item => item.arm_count === 0 && item.disarm_count === 0 && item.pulse_count === 0)) ? (
                                <div className={`${classes.fallbackMessage} ${isCollapsed ? classes.fallbackMessageCollapsed : ''}`}>
                                    <p>No users to display</p>
                                </div>
                        ) : (
                            <div className={`${classes.topUsersChart} ${isCollapsed ? classes.topUsersChartCollapsed : classes.topUsersChartCol}`}>
                                <div className={classes.userLegend}> 
                                    {topOutputData.slice(0, 5).map((item, index) => {
                                        const colors = ["#60e08f", "#6298ee", "#efbc65", "#df7474", "#75c71e"];
                                        return (
                                            <div
                                                key={item.user}
                                                className={classes.userLegendItem}
                                                onClick={() => {
                                                    if (item.id != null && item.id != 18965 && item.id != 4133 && item.id != 17103 && item.id != 17428) {
                                                        console.log('clicked on:', item.user, item.id);
                                                        handleUserClick(item.id, item.user);
                                                    }
                                                }}
                                            >
                                                <span
                                                    className={classes.userLegendDot}
                                                    style={{ backgroundColor: colors[index % colors.length] }}
                                                />
                                                <span>{item.user}</span>
                                            </div>
                                        );
                                    })}
                                </div>
                                <Bar
                                    data={outputBarData}
                                    options={{
                                        indexAxis: 'y',
                                        plugins: {
                                            legend: {
                                                display: false
                                            }
                                        }
                                    }}
                                />
                            </div>
                        )}

                    </div>
                </div>
                {topOutputData.length > 5 && (
                    <div className={`${classes.dataTableWrapper} ${!isCollapsed ? classes.dataTableWrapperCol : ''}`}>
                        <DataTable value={topOutputData} scrollable scrollHeight="400px" stripedRows style={{ border: "1px solid rgba(0, 0, 0, 0.2)", borderRadius: "8px", padding: "8px"}}>
                            <Column
                                field="user"
                                header="User"
                                body={(rowData) => (
                                    <span
                                        className={`${rowData.id != null && rowData.id !== 18965 && rowData.id !== 4133 && rowData.id !== 17103 && rowData.id !== 17428 ? classes.tableUser : ''}`}
                                        onClick={() => {
                                            if (rowData.id != null && rowData.id !== 18965 && rowData.id !== 4133 && rowData.id !== 17103 && rowData.id !== 17428) {
                                                handleUserClick(rowData.id, rowData.user);
                                            }
                                        }}
                                    >
                                        {rowData.user}
                                    </span>
                                )}
                            />
                            <Column field="count" header="Activity Count"></Column>
                        </DataTable>
                    </div>
                )}
                
            </>
            )}
            </>
        )}

        {tabs[activeTab] === "Padlocks" && (
            <>
            <div style={{ padding: '0px 22px'}}>
                <div className={classes.overviewHeader}>
                    <div className={classes.title}>
                        <h2>Padlock activity</h2>
                        <p>Open duration and usage statistics</p>
                    </div>
                    <div style={{ display: "flex", gap: "14px", marginLeft: "auto" }}>
                        <div>
                            <DatePickerModal show={showModal} onClose={HandleModalClose} title={modalTitle} onSelect={onSelect}>
                            {modalComponent}
                            </DatePickerModal>
                        </div>
                        <DateRangePicker style={{
                            display: "flex",
                            border: "1px solid #00000099",
                            borderRadius: "8px",
                            height: "30px",
                            maxWidth: "218px",
                            minWidth: isCollapsed ? "218px" : "150px"
                            }}
                            placement="bottomEnd"
                            format="yyyy.MM.dd"
                            onChange={(value) => handleOK(value, "lock")}
                            shouldDisableDate={disableDates}
                            calendarSnapping={true}
                            appearance="subtle"
                            onClean={() => {
                                setLockDateRange(null)
                                setSelectedTime("7D")
                            }}
                            cleanable={true}
                            ranges={[]}
                            value={lockDateRange ? [new Date(lockDateRange[0]), new Date(lockDateRange[1])] : null}
                        />
                        <div className={classes.timeButtons}>
                            {times.map((time) => (
                                <button
                                    key={time}
                                    className={selectedTime === time ? classes.timeButtonActive : classes.timeButton}
                                    onClick={() => {
                                        setSelectedTime(time)
                                        setLockDateRange(null)
                                    }}
                                >
                                    {time}
                                </button>
                            ))}
                        </div>
                    </div>
                </div>
                <div style={{ display: "flex", gap: "20px", marginTop: "20px", flexWrap: "wrap" }}>
                        <div style={{ flex: "1 1 200px", minWidth: "200px", maxWidth: "calc(50% - 10px)" }}>
                            <StatCard title={"Total opens"} value={lockStatCards.total} hasThirdValue={true} value3={`Most frequent: ${lockStatCards.mostFrequentUser}`}isLoading={isLoadingPadlocks} />
                        </div>
                        <div style={{ flex: "1 1 200px", minWidth: "200px", maxWidth: "calc(50% - 10px)" }}>
                            <StatCard title={"Total Open Time"} value={lockStatCards.totalOpenTime} hasThirdValue={true} value3={`Most by ${lockStatCards.highestTotalUser}`}isLoading={isLoadingPadlocks} />
                        </div>
                        <div style={{ flex: "1 1 200px", minWidth: "200px", maxWidth: "calc(50% - 10px)" }}>
                            <StatCard title={"Average Open Time"} value={lockStatCards.avgOpenTime} hasThirdValue={true} value3={lockStatCards.total > 1 ? `Across ${lockStatCards.total} opens` : `Across ${lockStatCards.total} open`} isLoading={isLoadingPadlocks} />
                        </div>
                        <div style={{ flex: "1 1 200px", minWidth: "200px", maxWidth: "calc(50% - 10px)" }}>
                            <StatCard title={"Longest Single Open"} value={lockStatCards.longestOpenTime} hasThirdValue={true} value3={`By ${lockStatCards.longestSingleUser}`} isLoading={isLoadingPadlocks} />
                        </div>
                    </div>
            
                {hasGateways && (
                <>
                    <br />
                    <LockOpenSection data={openLockData} cleanPinUsername={cleanPinUsername} dropdownOptions={dropdownOptions} timeConversion={timeConversion} handlePadlockOnClick={handlePadlockOnClick} isLoading={isLoadingLeftOpen} hasGateways={hasGateways} generatePadlockPDF={generatePadlockPDF}/>
                </>
                )}
                
                {/* 
                <br />
                <LockOpenSection data={openLockData} cleanPinUsername={cleanPinUsername} dropdownOptions={dropdownOptions} timeConversion={timeConversion} handlePadlockOnClick={handlePadlockOnClick} isLoading={isLoadingPadlocks}/>
            */}
            <br />
            
            <UnlockLockSection unlockLockRes={lockHistory} isCollapsed={isCollapsed} handleUserClick={handleUserClick} lockOnlyOptions={lockOnlyOptions} setSelectedPin={setSelectedPin} selectedPin={selectedPin} cleanPinUsername={cleanPinUsername} selectedTime={selectedTime} isLoading={isLoadingPadlocks} generatePadlockPDF={generatePadlockPDF} hasGateways={hasGateways}/>
            
            </div>
            </>
        )}

        </div>

        </div>
    );
}

export default AnalyticsPage;